import { CONSENT_STATUS } from './constants';

const getCrypto = () => (typeof window !== 'undefined' ? window.crypto : undefined);

// SHA-256 hex digest of the trimmed, lower case email, so the same email always gives the same id
// and the email itself is never sent. Undefined without an email or Web Crypto (https only)
export const hashEmail = async (email, cryptoObject = getCrypto()) => {
  const normalised = typeof email === 'string' ? email.trim().toLowerCase() : '';
  if (!normalised || !cryptoObject || !cryptoObject.subtle || typeof TextEncoder === 'undefined') {
    return undefined;
  }

  const digest = await cryptoObject.subtle.digest('SHA-256', new TextEncoder().encode(normalised));
  return Array.from(new Uint8Array(digest), byte => byte.toString(16).padStart(2, '0')).join('');
};

/**
 * Identifies a guest by their hashed email, so the anonymous browsing before registration and
 * repeat guest orders with the same email are linked to one person. Only with consent granted:
 * before a choice PostHog captures nothing, and denied users are captured without cookies.
 */
export default async function identifyGuest(posthog, { email } = {}, { hash = hashEmail } = {}) {
  if (posthog.get_explicit_consent_status() !== CONSENT_STATUS.GRANTED) return false;

  const distinctId = await hash(email);
  // consent can change while the email is hashed
  if (!distinctId || posthog.get_explicit_consent_status() !== CONSENT_STATUS.GRANTED) return false;

  posthog.identify(distinctId, { is_guest: true });
  return true;
}
